import { NylasGetThreadRequestContent, NylasGetThreadResponseContent } from "@equaliq/api-model-v2";
import { createApiRequest } from "../common";

/**
 * API function to get a single thread by ID
 * @param request Thread retrieval parameters (threadMetadataId)
 * @returns Promise with full thread metadata including AI-generated fields
 */
export const getIntegrationThreadApi = async (request: NylasGetThreadRequestContent): Promise<NylasGetThreadResponseContent> => {
  const apiRequest = createApiRequest<NylasGetThreadResponseContent>('post', '/integrations/nylas/threads/get');
  return apiRequest(request);
};
